import _isEmpty from 'lodash/isEmpty';

// State
import { addToCartDone as cartAddToCartDone } from '../cart/actions';
import cartApi from '../cart/api';
import catalogApi from './api';
import * as types from './actionTypes';

/**
 * Удаляет ингредиент
 *
 * @param {number} id - id товара
 * @param {number} variationId - id текущего варианта товара
 * @param {number} ingredientId - id ингредиента
 */
export const removeIngredient = (id, variationId, ingredientId) => ({
  type: types.REMOVE_INGREDIENT,
  payload: { id, variationId, ingredientId },
});

/**
 * Отменяем удаление ингредиентов
 *
 * @param {number} id - id товара
 * @param {number} variationId - id текущего варианта товара
 */
export const cancelRemovedIngredients = (id, variationId) => ({
  type: types.CANCEL_REMOVED_INGREDIENTS,
  payload: { id, variationId },
});

export const resetGood = id => ({
  type: types.RESET_GOOD,
  payload: { id },
});

export const changeDough = (id, doughType) => ({
  type: types.CHANGE_DOUGH,
  payload: { id, doughType },
});

export const changeSize = (id, size) => ({
  type: types.CHANGE_SIZE,
  payload: { id, size },
});

export const toggleStuffedCrust = (id, value) => ({
  type: types.TOGGLE_STUFFED_CRUST,
  payload: { id, value },
});

export const selectStuffedCrust = (id, value) => ({
  type: types.SELECT_STUFFED_CRUST,
  payload: { id, value },
});

//
function fetchGoodsStart() {
  return { type: types.FETCH_GOODS_REQUEST };
}

function fetchGoodsDone(data) {
  return {
    type: types.FETCH_GOODS_SUCCESS,
    payload: data,
  };
}

function fetchGoodsFail() {
  return {
    type: types.FETCH_GOODS_FAILURE,
    hasError: true,
  };
}

export const fetchGoods = params => {
  return dispatch => {
    dispatch(fetchGoodsStart());

    return catalogApi
      .getGoods(params)
      .then(data => dispatch(fetchGoodsDone(data)))
      .catch(() => dispatch(fetchGoodsFail()));
  };
};

//

function fetchGoodStart(id) {
  return {
    type: types.FETCH_GOOD_REQUEST,
    payload: { id },
  };
}

function fetchGoodDone(id, data) {
  return {
    type: types.FETCH_GOOD_SUCCESS,
    payload: { id, data },
  };
}

function fetchGoodFail(id, error) {
  return {
    type: types.FETCH_GOOD_FAILURE,
    payload: { id, error },
  };
}

export const fetchGood = (id, req = {}) => {
  return dispatch => {
    dispatch(fetchGoodStart(id));

    return catalogApi
      .getGood(id, req)
      .then(data => dispatch(fetchGoodDone(id, data)))
      .catch(error => dispatch(fetchGoodFail(id, error)));
  };
};

export const fetchGoodIsNeeded = id => {
  return (dispatch, getState) => {
    const goods = getState().catalog.products.list;
    const goodIdx = goods.findIndex(good => good.id === Number(id));
    const good = goods[goodIdx];

    if (_isEmpty(good)) {
      return dispatch(fetchGood(id));
    }

    return false;
  };
};

//

function addToCartStart(id) {
  return {
    type: types.ADD_TO_CART_REQUEST,
    payload: id,
  };
}

function addToCartDone(id) {
  return {
    type: types.ADD_TO_CART_SUCCESS,
    payload: id,
  };
}

function addToCartFail(id, error) {
  return {
    type: types.ADD_TO_CART_FAILURE,
    payload: { id, error },
  };
}

export const addToCart = (id, composition, isUpsale) => {
  return dispatch => {
    dispatch(addToCartStart(id));

    return cartApi
      .addToCart(composition, isUpsale)
      .then(data => {
        const variationId = composition?.[0]?.item?.id;
        dispatch(addToCartDone(id));

        if (variationId) {
          const lastAddedItem = data.composition.find(el => el.item.id === variationId);
          dispatch(cartAddToCartDone(data, lastAddedItem));

          return dispatch(cancelRemovedIngredients(id, variationId));
        }

        return dispatch(cartAddToCartDone(data));
      })
      .catch(({ message }) => dispatch(addToCartFail(id, message)));
  };
};

//

function requestIngredientsStart() {
  return { type: types.FETCH_INGREDIENTS_REQUEST };
}

function requestIngredientsDone(data) {
  return {
    type: types.FETCH_INGREDIENTS_SUCCESS,
    payload: data,
  };
}

function requestIngredientsFail() {
  return {
    type: types.FETCH_INGREDIENTS_FAILURE,
    hasError: true,
  };
}

export const fetchIngredients = () => {
  return dispatch => {
    dispatch(requestIngredientsStart());

    return catalogApi
      .getIngredients()
      .then(data => dispatch(requestIngredientsDone(data)))
      .catch(() => dispatch(requestIngredientsFail()));
  };
};

export const fetchIngredientsIsNeeded = () => {
  return (dispatch, getState) => {
    const {
      catalog: { ingredients },
    } = getState();

    if (!ingredients.isLoading && !ingredients.isLoaded) {
      return dispatch(fetchIngredients());
    }

    return false;
  };
};

//

function requestPizzaFilterStart() {
  return { type: types.FETCH_PIZZAFILTER_REQUEST };
}

function requestPizzaFilterDone(data) {
  return {
    type: types.FETCH_PIZZAFILTER_SUCCESS,
    payload: data,
  };
}

function requestPizzaFilterFail() {
  return {
    type: types.FETCH_PIZZAFILTER_FAILURE,
    hasError: true,
  };
}

export const fetchPizzaFilter = () => {
  return dispatch => {
    dispatch(requestPizzaFilterStart());

    return catalogApi
      .getActiveIngredients()
      .then(data => dispatch(requestPizzaFilterDone(data)))
      .catch(() => dispatch(requestPizzaFilterFail()));
  };
};

export const fetchPizzaFilterIsNeeded = () => {
  return (dispatch, getState) => {
    const {
      catalog: { pizzaFilter },
    } = getState();

    if (!pizzaFilter.isLoading && !pizzaFilter.isLoaded) {
      return dispatch(fetchPizzaFilter());
    }

    return Promise.resolve();
  };
};

//

export const fetchUpsale = () => {
  return dispatch => {
    dispatch({ type: types.FETCH_UPSALE_REQUEST });

    return catalogApi
      .getUpsale()
      .then(payload => {
        return dispatch({ type: types.FETCH_UPSALE_SUCCESS, payload });
      })
      .catch(() => {
        return dispatch({ type: types.FETCH_UPSALE_FAILURE });
      });
  };
};

export function addToCartFromUpsale(payload) {
  return { type: types.ADD_TO_CART_FROM_UPSALE, payload };
}
